import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getAllPersonnelinMap() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PROCESSUS_MAP_PERSONNEL
      )
    ).data;
  },

  async getAllDRHinMap() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PROCESSUS_MAP_DRH
      )
    ).data;
  },

  async getAllAdmininMap() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PROCESSUS_MAP_ADMIN
      )
    ).data;
  },

  async getAllConsultationinMap() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PROCESSUS_MAP_CONSULTATION
      )
    ).data;
  },

  async getAllConsultationPIECEinMap() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PROCESSUS_MAP_consultation_PIECE
      )
    ).data;
  },

  async getAll() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_PROCESSUS
      )
    ).data;
  },

  async update(processus) {
    return (
      await axios.put(
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_PROCESSUS,
        processus
      )
    ).data;
  },

  async getAllCount() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PROCESSUS_COUNT
      )
    ).data;
  },
};
